import React, { useState } from "react";
import classnames from "classnames";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditButton from "./edit-user-button";
import DeleteButton from "./delete-user-button";
import PhotoButton from "./upload-photo";

const DEFAULT_IMG =
  "https://s3.us-east-2.amazonaws.com/vgde-researchers-photos/placeholder-image-768x576.jpg";

const styles = theme => ({
  card: {
    display: "flex"
  },
  details: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  cover: {
    minWidth: 300
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit
  }
});

const ResearcherCard = props => {
  const { classes, row, query } = props;
  const [expanded, changeExpanded] = useState(false);

  const handleExpandClick = () => changeExpanded(!expanded);

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cover}
        image={row.photo || DEFAULT_IMG}
        title={row.name}
      />

      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="h5" variant="h5">
            {row.name}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {row.credentials}
          </Typography>
          <Row end="xs">
            <Col xs={12}>
              <IconButton
                className={classnames(classes.expand, {
                  [classes.expandOpen]: expanded
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="Show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </Col>
            <Col xs={12}>
              <Collapse in={expanded} collapsedHeight="50px">
                {row.descriptions.map((description, index) => {
                  return (
                    <Typography variant="body1" gutterBottom key={index}>
                      {description}
                    </Typography>
                  );
                })}
              </Collapse>
            </Col>
          </Row>
        </CardContent>
        <div className={classes.controls}>
          <PhotoButton row={row} query={query} />
          <EditButton row={row} query={query} />
          <DeleteButton row={row} query={query} />
        </div>
      </div>
    </Card>
  );
};

export default withStyles(styles)(ResearcherCard);



// WEBPACK FOOTER //
// ./src/components/researchers/card-item.js